import React, {Component, ReactNode} from 'react'
import {
    StyledDiv,
    StyledImg,
    StyledLi,
    StyledSpan,
    StyledTable,
    StyledTd,
    StyledTr,
    StyledUl
} from '../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import {Smartphone, Computer} from '@mui/icons-material';
import { Paper } from '@mui/material';

interface Props {
    condominiumName: string
    ridgeName: string
    roomNumber: string
    issueDate: string
    authenticationKey: string
    firstLoginAccessUrl: string
}

export default class NatAuthKeyNoticePrintComponent extends Component<Props> {

    async componentDidMount(): Promise<void> {
    }
    render(): ReactNode {
        return <>
            <Paper>
                <PageDiv>
                    <Header>
                        <UserHead>
                            {/* tslint:disable-next-line:max-line-length */}
                            {this.props.condominiumName && <>{this.props.condominiumName}<br/></>}
                            {this.props.ridgeName && <>{this.props.ridgeName}<br/></>}
                            {this.props.roomNumber}号室 居住者様
                        </UserHead>
                        <SutekiHead>
                            <MiniText>マンションライフをもっと素敵に。</MiniText>
                            <SutekiImg src={`/resources/images/print/suteki_logo.png`}/>
                        </SutekiHead>
                    </Header>
                    <MainClauseDiv>
                        <TitleDiv>素敵ネット登録に関するお知らせ</TitleDiv>
                        <br/>
                        <div>　日頃より弊社管理業務に対し格別のご高配を賜り、厚くお礼申し上げます。</div>
                        <div>「素敵ネット」はスマートフォン等からお住まいのマンション専用の各種情報（管理規約や管理組合からのお知らせ等）へのアクセスができるサービスです。</div>
                        <div>ご利用いただくための登録方法等について以下の通りお知らせ申し上げます。</div>
                        <br/>
                        <div>【素敵ネットのご利用について】</div>
                        <DescriptionUl>
                            <DescriptionLi>会員登録が必要です（無料）。</DescriptionLi>
                            <DescriptionLi>会員登録いただいた後は、ご自身のメールアドレスと任意のパスワードでアクセスしていただきます。</DescriptionLi>
                            <DescriptionLi>メインユーザご登録後、同居されている方４名までをサブユーザとして登録できます。
                                <br/>※詳細は素敵ネット内「FAQ よくある質問」Q18をご確認ください。</DescriptionLi>
                        </DescriptionUl>
                    </MainClauseDiv>
                    <AuthKeyTable>
                        <tbody>
                        <AuthKeyTr>
                            <AuthKeyTitleTd colSpan={2}><CustomSmartphone/><CustomComputer/>
                                <TitleText>WEBでご登録</TitleText></AuthKeyTitleTd>
                        </AuthKeyTr>
                        <AuthKeyTr>
                            <UrlQrTd>
                                <GuideText>①　以下のコードから</GuideText>
                                <AuthKeyItem>
                                    <QRCode
                                    value={`${this.props.firstLoginAccessUrl}`}
                                    size={60}
                                    style={{verticalAlign: 'middle', margin: '8px', marginLeft: '24px'}}/>
                                    <AuthLinkContentsText>または</AuthLinkContentsText>
                                </AuthKeyItem>
                            </UrlQrTd>
                            <AuthUrlTd>
                                <GuideText>②　URLから</GuideText>
                                <UrlText>https://www.suteki.haseko.jp/</UrlText>
                            </AuthUrlTd>
                        </AuthKeyTr>
                        <AuthKeyTr>
                            <AuthKeyContentsTd colSpan={2}>
                                <div><strong>初回認証キー</strong>（WEB 画面で以下を入力してください）</div>
                                <AuthKey>{this.props.authenticationKey}</AuthKey>
                            </AuthKeyContentsTd>
                        </AuthKeyTr>
                        </tbody>
                    </AuthKeyTable>
                    <NotesUl>
                        <NotesLi>上記のQRコードを読み取ると認証キーの入力をせずに登録可能です。</NotesLi>
                        <NotesLi>手動で認証キーを入力される場合、全て半角英数字、英字は小文字でご入力ください。</NotesLi>
                        <NotesLi>「0」はアルファベットの「オー」ではなく、半角数字「ゼロ」です。</NotesLi>
                        <NotesLi>ご登録が完了されましたら、上記認証キーは使用できません。</NotesLi>
                        <br/>
                        <NotesLi>サイトを閲覧する際の推奨ブラウザについてはサイト上のFAQをご確認ください。</NotesLi>
                        <NotesLi>スマートフォンを利用される場合は「プライベートブラウズ機能」をオフにしてください。</NotesLi>
                        <NotesLi>詳しくは、素敵ネットログイン画面の<Enclosure>ユーザ登録の手順はこちら</Enclosure>をご参照ください。</NotesLi>
                        <br/>
                        <NotesLi>「App Store」「Google Play」にて“素敵ネット”を検索し、アプリをダウンロードしてご利用ください。</NotesLi>
                    </NotesUl>
                    <ContactUs>
                        <TitleDiv>ログインに関するお問い合わせ</TitleDiv>
                        <div>長谷工コミュニティ素敵生活サービスデスク  <CotactPhoneNumber>0120-875-532</CotactPhoneNumber></div>
                        <CotactTimeText>＜受付＞8:00～20:00 年中無休（年末年始除く）</CotactTimeText>
                    </ContactUs>
                    <Footer1>
                        <FooterImg src={`/resources/images/print/haseko_logo.png`}/>
                    </Footer1>
                </PageDiv>
            </Paper>
        </>
    }
}


const PageDiv: StyledDiv = styled.div`
            width: 170mm;
            height: 296.9mm;
            padding: 18mm 20mm 0mm 20mm;
            font-size: 11pt;
            font-family: "ipag";
`;

const Header: StyledDiv = styled.div`
            display: flex;
            padding-left: 5mm;
            width: 170mm;
`;

const UserHead: StyledDiv = styled.div`
            display: inline-block;
            width: 135mm;
            height: 30mm;
            padding-top: 3mm;
            padding-left: 10pt;
            word-break: break-all;
            font-size: 10pt;
`;

const MiniText: StyledDiv = styled.div`
            font-size: 7px;
`;

const SutekiImg: StyledImg = styled.img`
            width: 100%;
            height: auto;
            position: relative;
`;

const SutekiHead: StyledDiv = styled.div`
            display: inline-block;
            width: 30mm;
            height: 30mm;
            text-align: right;
`;

const MainClauseDiv: StyledDiv = styled.div`
            line-height: 5mm;
            width: 170mm;
            margin-top: 30pt;
`;

const TitleDiv: StyledDiv = styled.div`
            text-align: center;
            text-decoration: underline;
            font-size: 12pt;
`;

const DescriptionUl: StyledUl = styled.ul`
            list-style-type: none;
            padding-left: 0;
            margin-top: 0;
`;

const DescriptionLi: StyledLi = styled.li`
            padding-left: 22pt;
            position: relative;
            :before{
                content: "◆";
                left: 8pt;
                margin-right: 5px;
                font-size: 7pt;
                position: absolute;
            }
`;

const AuthKeyTable: StyledTable = styled.table`
            border-collapse: collapse;
            font-size: 10pt;
            width: 170mm;
            margin-left: 0.5em;
            margin-right:auto;
`;

const AuthKeyTr: StyledTr = styled.tr`
            border: solid 0.5pt black;
            text-align: left;
`;

const AuthKeyTd: StyledTd = styled.td`
            padding-top: 5pt;
`;

const AuthKeyTitleTd = styled(AuthKeyTd)`
            padding-top: 0;
            background-color:#7f7f7f;
            padding-left: 120pt;
            vertical-align: middle;
            color: white;
`;

const UrlQrTd = styled(AuthKeyTd)`
            text-align: center;
`;

const AuthUrlTd = styled(AuthKeyTd)`
            padding-left: none;
            padding-right: 12pt;
            vertical-align: top;
`;

const AuthKeyContentsTd = styled(AuthKeyTd)`
            padding-left: 50pt;
`;

const CustomSmartphone = styled(Smartphone)`
            vertical-align: middle;
            &&& {
                font-size: 28pt;
            }
`;

const CustomComputer = styled(Computer)`
            vertical-align: middle;
            &&& {
                font-size: 40pt;
            }
`;

const TitleText: StyledSpan = styled.span`
            padding-left: 20pt;
            font-weight: bold;
            font-size: 12pt;
`;

const GuideText: StyledDiv = styled.div`
            padding-left: 10pt;
`;

const AuthKeyItem: StyledSpan = styled.span`
            padding-left: 60pt;
`;

const AuthLinkContentsText: StyledSpan = styled.span`
            padding-left: 30px;
`;

const UrlText: StyledDiv = styled.div`
            text-decoration: underline;
            padding-top: 16pt;
            padding-left: 10pt;
            font-size: 14pt;
`;

const AuthKey: StyledDiv = styled.div`
            font-size: 18pt;
            font-weight: bold;
            padding-left: 50pt;
`;

const NotesUl: StyledUl = styled.ul`
            width: 172mm;
            list-style-type: none;
            padding-left: 0;
            margin-top: 0;
`;

const NotesLi: StyledLi = styled.li`
            padding-left: 20pt;
            position: relative;
            :before{
                content: "※";
                left: 0;
                margin-right: 10px;
                position: absolute;
            }
`;

const Enclosure: StyledSpan = styled.span`
            border-color: #1a1a1a;
            border-style: solid;
            border-width:0.5pt;
            padding-top: 1pt;
            padding-bottom: 0pt;
            margin-right: 10pt;
            margin-left: 10pt;
`;

const ContactUs: StyledDiv = styled.div`
            text-align: center;
            width: 170mm;
            line-height: 6mm;
            font-size: 11pt;
`;

const CotactTimeText: StyledDiv = styled.div`
            font-size: 9pt;
`;

const CotactPhoneNumber: StyledSpan = styled.span`
            font-size: 14pt;
            padding-left: 20pt;
`;

const Footer1: StyledDiv = styled.div`
            width: 170mm;
            text-align: center;
`;

const FooterImg: StyledImg = styled.img`
            width: 35%;
            height: auto;
`;